import kalaSpotlight from "../../assets/events/kala-spotlight.jpeg";
import thaiThaiVithai from "../../assets/events/thai-thai-vithai.jpeg";
import comingSoonWallpaper from "../../assets/responsive_wallpaper.png";
import kalarambh2026Poster from "../../assets/events/kalarambh-2026-poster.png";
import tichiShappath from "../../assets/events/tichi_shappath.jpeg";
import rooBaRoo2026 from "../../assets/events/roo-ba-roo_26-27.jpeg";

export const resolveEventStatus = (event) => {
  if (event.status) return event.status;
  if (event.comingSoon) return "upcoming";
  return "past";
};

const events = [
  {
    index: 17,
    Name: 'Tichi Shappath (तिची शप्पथ)',
    tagline: 'कविता, गझला आणि बरंच काही',
    date: '24 October 2026 (Saturday), 5:00 PM',
    venue: 'Tilak Hall, Walchand College of Engineering, Sangli',
    entry: 'Free entry (विनामूल्य प्रवेश), limited seats, first come first served',
    contact: 'Ayush 7447781876, Parth 8432530509',
    description:
      'Tichi Shappath is an evening of कविता, गझला आणि बरंच काही — poetry, ghazals and much more, presented by WCE Art Circle at Tilak Hall, Walchand College of Engineering, Sangli on 24 October 2026 at 5:00 PM. Entry is free (विनामूल्य प्रवेश) with limited seats on a first come, first served basis, so register early to reserve your spot.',
    icon: tichiShappath,
    register: "https://konfhub.com/tichi-shappath",
    status: "live",
  },
  {
    index: 18,
    Name: 'Roo-Ba-Roo (aka Dandiya Night 2026)',
    date: '15 October 2026, 5:30 PM - 9:00 PM',
    venue: 'OAT, Walchand College of Engineering, Sangli',
    entry: 'Free entry to all (ID card required)',
    presentedBy: 'WCE Art Circle with Social Media Club',
    description:
      'Roo-Ba-Roo (aka Dandiya Night 2026) was one of the most awaited nights of the year for WCE Art Circle, celebrated with the energy and enthusiasm of Navratri on 15 October 2026, 5:30 PM - 9:00 PM at the Open Air Theatre (OAT), Walchand College of Engineering, Sangli. Presented by WCE Art Circle with Social Media Club, members performed choreographed dandiya dances while attendees dressed in traditional Gujarati attire, with dandiyas provided by the club. Free entry to all (ID card required).',
    icon: rooBaRoo2026,
    status: "past",
  },
  {
    index: 10,
    Name: 'Kala Spotlight (Art Circle Day)',
    description:
      "Kala Spotlight is the signature celebration of WCE Art Circle Day, dedicated to honoring the passion, creativity, and talent of our artists. Through mesmerizing performances, inspiring exhibitions, and vibrant cultural expressions, the event shines a spotlight on every art form that defines our club, celebrating the spirit of imagination, collaboration, and artistic excellence.",
    icon: kalaSpotlight,
  },
  {
    index: 11,
    Name: 'Thai Thai Vithai (Ashadhi Ekadashi)',
    description:
      "Thai Thai Vithai is a vibrant celebration inspired by the sacred occasion of Ashadhi Ekadashi, where art becomes an expression of devotion. Through mesmerizing dance, soulful music, and captivating cultural performances, the event honors Maharashtra's rich spiritual heritage while inspiring creativity, unity, and a deep appreciation for our timeless traditions.",
    icon: thaiThaiVithai,
  },
  {
    index: 12,
    Name: 'Kalarambh (GIM)',
    description:
      'Kalarambh is the most awaited and celebrated event of Art Circle. It is a General Interest Meet (GIM) arranged for newly admitted first-year members to get a complete picture of Art Circle and the events it organizes throughout the year. Kalarambh gives every team in Art Circle the chance to showcase its talent and inspire new artists to join and grow their skills. As the name suggests, it marks the beautiful beginning of an artistic journey for first-year members over their four years at WCE.',
     icon: "   https://cdn.statically.io/gh/wce-artcircle/Assets/main/events/Yuvarang%202026.png",
    status: "past",
  },
  {
    index: 14,
    Name: 'Deepotsav',
    description:
      'Deepotsav is Art Circle\u2019s celebration of light and festivity, bringing members together to mark the spirit of the season.',
    icon: comingSoonWallpaper,
    comingSoon: true,
  },
  {
    index: 15,
    Name: 'Yuvarang 2027',
    description:
      'Yuvarang is the signature event of Art Circle and the only cultural mega-event of WCE Sangli, open to all colleges and every trade. Art Circle brings together every artform under one roof — drama, dance, music, and content writing including poetry and sketching — and even gives school-going children a stage to showcase their talent. Every year, Art Circle works to preserve, promote, and celebrate the artforms of India, and Yuvarang 2027 continues that tradition.',
    icon: comingSoonWallpaper,
    comingSoon: true,
  },
  {
    index: 16,
    Name: 'Kalarambh 2026 (कलारंभ २०२६)',
    description:
      'नांदी नवपर्वाची...',
    icon: kalarambh2026Poster,
    status: "past",
  },
  {
    index: 1,
    Name: 'Yuvarang 2026',
    description:
      'Yuvarang is the signature event of Art Circle. It is the only cultural mega event of WCE Sangli. The event is open to all colleges and for all trades. Art Circle tries to cover and enhance all the artforms in all the domains - drama, dance, music or content writing like poetry sketching colouring and many more. Art Circle also gives an opportunity to school going children to showcase their talent. We members of Art Circle always try to preserve the culture,promote and encourage the artforms of India and always try to do our best in this initiative',
    icon: "   https://cdn.statically.io/gh/wce-artcircle/Assets/main/events/Yuvarang%202026.png",
    register: "https://konfhub.com/yuvarang-2026"
  },
    {
    index: 2,
    Name: 'GIM 2025',
    description:
      'Kalarambh is the most awaited and most celebrated event of ArtCircle. It is basically General interest meet(GIM) arranged for newly admitted first year members to get the overall idea about the ArtCircle and events arranged by ArtCircle. Kalarambh is the golden opportunity for all the teams of ArtCircle to showcase their talent and encourage the new artists to be a part of ArtCircle to enhance and polish their artistic skills by joining ArtCircle.As the name suggests its the beautiful beginning of the art for the first year members in their 4 year journey with WCE.',
    icon: "https://cdn.statically.io/gh/wce-artcircle/Assets/main/events/GIM%202025%20.jpeg",
    more: ""
  },

  {
    index: 3,
    Name: 'Yuvarang 2025',
    description:
      'Yuvarang is the signature event of Art Circle. It is the only cultural mega event of WCE Sangli. The event is open to all colleges and for all trades. Art Circle tries to cover and enhance all the artforms in all the domains - drama, dance, music or content writing like poetry sketching colouring and many more. Art Circle also gives an opportunity to school going children to showcase their talent. We members of Art Circle always try to preserve the culture,promote and encourage the artforms of India and always try to do our best in this initiative',
    icon: "    https://cdn.statically.io/gh/wce-artcircle/Assets/main/events/yuvarangf1-2025.jpg",
    //register: "https://konfhub.com/yuvarang-2025"
  },
  {
    index: 4,
    Name: 'GIM 2024',
    description:
      'Kalarambh is the most awaited and most celebrated event of ArtCircle. It is basically General interest meet(GIM) arranged for newly admitted first year members to get the overall idea about the ArtCircle and events arranged by ArtCircle. Kalarambh is the golden opportunity for all the teams of ArtCircle to showcase their talent and encourage the new artists to be a part of ArtCircle to enhance and polish their artistic skills by joining ArtCircle.As the name suggests its the beautiful beginning of the art for the first year members in their 4 year journey with WCE.',
    icon: "https://cdn.statically.io/gh/wce-artcircle/Assets/main/events/Kalarambh.jpg",
    // register: "https://konfhub.com/gim-2024"
  },
  {
    index: 5,
    Name: 'Ganjyot 2024',
    description:
      'It is a Photography Competition which aims at celebrating Ganpati Festival and capturing it with a different perspective. The competition is open to all WCE students. The participants are required to click a photograph of Ganpati Bappa in the campus and submit it to the club. The best photographs are selected by the judges and the winners are awarded Free ticket to GIM 2024. The competition is a great opportunity for the students to showcase their photography skills and creativity.',
    icon: "https://cdn.statically.io/gh/wce-artcircle/Assets/main/events/Ganjyot.jpg",
    more: ""
  },
  {

    index: 6,
    Name: 'Dandiya Nights 2023',
    description:
      'Dandiya Nights is the most awaited program of WCE ART Circle, which typically falls in October. It is celebrated at Open Air Theatre of WCE with great energy and enthusiasm. The members of Art Circle perform dandiya dance which is set beforehand. On the event day, individuals attire themselves in the traditional Gujarati fashion. Dandiyas(sticks) are also provided by the club. An energetic and colourful aura is formed with the beats of song and dance.',
    icon: "https://cdn.statically.io/gh/wce-artcircle/Assets/main/events/2023-navratri.png",
  },
  {
    index: 7,
    Name: 'YUVARANG 2023',
    description:
      'Yuvarang is the signature event of ArtCircle. It is the only cultural mega event of WCE Sangli. The event is open to all colleges and for all trades. ArtCircle tries to cover and enhance all the artforms in all the domains (eg- drama ,dance,music, litrature or Content writing like poetry sketching colouring and many more. ArtCircle also gives an opportunity to school going children to showcase their talent.We members of ArtCircle always try to preserve the culture,promote and encourage the artforms of India and alwyas try to do our best in this initiative',
    icon: "https://cdn.statically.io/gh/wce-artcircle/Assets/main/events/yuvarang-23.jpeg",
  },
  {
    index: 8,
    Name: 'VARSHAV 2023',
    description:
      'Varshav is the newly added online photography competition introduced by Wce ArtCircle. It is an online photography competition exclusively for WCE students.Varshav promotes nature photography during Rainy season which also gives the message of environment conservation. WCE has always been rich and blessed with natural greeney which is more beautified by the Rains. Almost everyone in the campus is amazed by the scenic beauty and captures it in a photograph. This fondness of nature by fellow students of WCE needs an appreciation and  ArtCircle tries its best to do so via Varshav.',
    icon: "https://cdn.statically.io/gh/wce-artcircle/Assets/main/events/photography-contest.png",
  },
  {
    index: 9,
    Name: 'FAREWELL 2023',
    description:
      'Runanubandh is every emotional and close to heart event for all the ArtCircle members. It is a  farewell cum declaration program, where the current assistant and joint board members arrange the farewell for the Chief board and then the newly elected president, chief board and joint board members are declared. It is followed by the games that refresh the memories of all the ArtCircle members that the experienced during their tenure and motivates the newly elected board to do the same.The program is concluded with the oath by the newly elected president and board members and then followed by taking hand impressions of the Ex- Chief board members to preserve the memories.Overall the program is filled with all kinds of emotions and is exclusively for only ArtCircle members.',
    icon: "https://cdn.statically.io/gh/wce-artcircle/Assets/main/events/farewell.png",
  },
]
export default events